<template>
  <b-card class="shadow" style="min-height: 700px" ref="printMe">
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h1 class="h3 mb-0 text-gray-800">
            {{ $t("Gráficos") }}
          </h1>

          <b-button-group>
            <b-button
              variant="outline-dark"
              :class="viewFilterReport === true ? 'active' : ''"
              @click="viewFilters"
            >
              <i class="fas fa-filter"></i>
              {{ $t("Filtros") }}
            </b-button>
            <b-button
              variant="outline-dark"
              :class="range === 'weekly' ? 'active' : ''"
              @click="updateAnalytics('weekly')"
            >
              <i class="fas fa-calendar-week"></i>
              {{ $t("Weekly") }}
            </b-button>
            <b-button
              variant="outline-dark"
              :class="range === 'monthly' ? 'active' : ''"
              @click="updateAnalytics('monthly')"
            >
              <i class="fas fa-calendar-alt"></i>
              {{ $t("Monthly") }}
            </b-button>
            <b-button
              variant="outline-dark"
              :class="range === 'yearly' ? 'active' : ''"
              @click="updateAnalytics('yearly')"
            >
              <i class="fas fa-calendar"></i>
              {{ $t("Yearly") }}
            </b-button>
          </b-button-group>
        </div>
      </div>

      <filter-reports
        :report="report"
        @loadlist="getAnalytics"
        :showFilterReport="viewFilterReport"
        @hideFilter="viewFilters"
        :data_inicio="data_inicio"
        :data_fim="data_fim"
        @update:data_inicio="data_inicio = $event"
        @update:data_fim="data_fim = $event"
      ></filter-reports>

      <div class="col-md-12 no-print">
        <b-tabs content-class="mt-3">
          <b-tab
            title="Pessoas por Renda"
            active
            @click.prevent="changeTab('Pessoas por Renda')"
          >
            <div
              class="col-md-12"
              style="min-height: 700px"
              v-if="tabAtiva == 'Pessoas por Renda'"
            >
              <donut-graph
                titulo="Pessoas por Renda"
                :loading="loading"
                :data="report.percapita"
                :range="range"
              />
            </div>
            <div class="col-md-12">
              <p class="text-muted small pb-1 mb-1">
                Total de
                <b v-if="report.totalFamiliasPercapita"
                  >({{ report.totalFamiliasPercapita }})
                </b>
                Pessoas com dados de renda no campo "(Se sim, registre o valor
                bruto da remuneração efetivamente recebida)" do cadastrado único
                ou inseridos por algum técnico
              </p>
            </div>
          </b-tab>
          <b-tab
            title="Pessoas por Cor/Raça"
            @click.prevent="changeTab('Pessoas por Cor/Raça')"
          >
            <div class="row">
              <div
                class="col-md-12"
                style="min-height: 700px"
                v-if="tabAtiva == 'Pessoas por Cor/Raça'"
              >
                <donut-graph
                  :loading="loading"
                  :data="report.corraca"
                  :range="range"
                />
              </div>
              <div class="col-md-12">
                <p class="text-muted small">
                  Total de
                  <b v-if="report.totalPessoasCorRaca"
                    >({{ report.totalPessoasCorRaca }})</b
                  >
                  pessoas com estado cadastral "Cadastrado" e o campo "Cor/Raça"
                  devidamente preenchido.
                </p>
              </div>
            </div>
          </b-tab>
          <b-tab
            title="Pessoas por Sexo"
            @click.prevent="changeTab('Pessoas por Sexo')"
          >
            <div class="row" v-if="tabAtiva == 'Pessoas por Sexo'">
              <div class="col-md-12" style="min-height: 700px">
                <donut-graph
                  :loading="loading"
                  :data="report.sexo"
                  :range="range"
                />
              </div>
              <div class="col-md-12">
                <p class="text-muted small">
                  Total de
                  <b v-if="report.totalPessoasSexo"
                    >({{ report.totalPessoasSexo }})</b
                  >
                  pessoas com estado cadastral "Cadastrado" e o campo "Sexo"
                  devidamente preenchido.
                </p>
              </div>
            </div>
          </b-tab>
          <b-tab
            title="Pessoas por Faixa Etária"
            @click.prevent="changeTab('Pessoas por Faixa Etária')"
          >
            <div class="row">
              <div
                class="col-md-12"
                style="min-height: 700px"
                v-if="tabAtiva == 'Pessoas por Faixa Etária'"
              >
                <donut-graph
                  :loading="loading"
                  :data="report.faixaetaria"
                  :range="range"
                />
              </div>
              <div class="col-md-12">
                <p class="text-muted small">
                  Total de
                  <b v-if="report.totalPessoasFaixaEtaria"
                    >({{ report.totalPessoasFaixaEtaria }})</b
                  >
                  pessoas com estado cadastral "Cadastrado" e o campo "Data de
                  Nascimento" devidamente preenchido.
                </p>
              </div>
            </div>
          </b-tab>

          <b-tab
            title="Pessoas Deficientes"
            @click.prevent="changeTab('Pessoas Deficientes')"
          >
            <div class="row">
              <div
                class="col-md-12"
                style="min-height: 700px"
                v-if="tabAtiva == 'Pessoas Deficientes'"
              >
                <donut-graph
                  :loading="loading"
                  :data="report.deficiencias"
                  :range="range"
                />
              </div>
              <!-- <div class="col-md-12">
                <p class="text-muted small">
                  Total de
                  <b v-if="report.totalPessoasFaixaEtaria"
                    >({{ report.totalPessoasFaixaEtaria }})</b
                  >
                  pessoas com estado cadastral "Cadastrado" e o campo "Data de
                  Nascimento" devidamente preenchido.
                </p>
              </div> -->
            </div>
          </b-tab>

          <b-tab
            title="Pessoas por Escolaridade"
            @click.prevent="changeTab('Pessoas por Escolaridade')"
          >
            <div class="row">
              <div
                class="col-md-12"
                style="min-height: 700px"
                v-if="tabAtiva == 'Pessoas por Escolaridade'"
              >
                <loading-animation
                  :active.sync="loading"
                  :is-full-page="false"
                  :opacity="1"
                  color="#5895FF"
                />
                <span v-if="report.escolaridade.length == 0">
                  <div class="row align-items-center text-center empty-graph">
                    <div class="col">
                      <img
                        :alt="$t('No results')"
                        class="mb-3"
                        src="/img/graphics/statistic_chart.svg"
                        style="max-height: 100px"
                      />
                      <h5>{{ $t("No records available") }}</h5>
                    </div>
                  </div>
                </span>
                <bar-chart
                  v-else
                  :data="report.escolaridade"
                  :range="range"
                  style="height: 350px"
                />
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <div class="col-md-12 text-center">
        <b-button
          :title="$t('Imprimir')"
          class="py-2"
          size="sm"
          type="button"
          v-b-tooltip.hover
          variant="primary"
          @click="printHtml()"
        >
          <i class="fas fa-print"></i>
        </b-button>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "HomeReportFamilias",
  data() {
    return {
      loading: true,
      range: "yearly",
      graficoUsuarios: true,
      graficoGrupos: false,
      report: {
        percapita: [],
        corraca: [],
        usuarios: [],
        deficiencias: [],
        datas: {
          start: "",
          end: "",
        },
      },
      filtros: {},
      tabAtiva: "Pessoas por Renda",
      output: null,
      data_inicio: "",
      data_fim: ""
    };
  },
  mounted() {
    this.getAnalytics();
  },
  methods: {
    changeTab(value) {
      if (value) {
        this.tabAtiva = value;
      } else {
        this.tabAtiva = "Pessoas por Renda";
      }
      this.getAnalytics();
    },
    updateAnalytics(range) {
      if (this.range !== range) {
        this.range = range;
        this.getAnalytics();
      }
    },
    getAnalytics() {
      if (this.data_inicio) {
        this.filtros.data_inicial = this.$options.filters.formatDateYMD(
          this.data_inicio
        );
      }
      if (this.data_fim) {
        this.filtros.data_final = this.$options.filters.formatDateYMD(
          this.data_fim
        );
      }

      this.loading = true;
      const tab = { tab: this.tabAtiva };
      axios
        .get("api/dashboard/report/usuarios/graficos", {
          params: {
            range: this.range,
            filtros: this.filtros,
            ...tab,
          },
        })
        .then((response) => {
          this.loading = false;
          this.report = response.data.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

